import styles from './styles/CategoryTitle.module.scss';

const NavBarTitle = ({ title }: { title?: string }) => {
  return <span className={styles['span']}>{title}</span>;
};

export default NavBarTitle;
